<template>
  <div class="login-page">
    <div class="login-container">
      <h2>登录</h2>
      <div class="login-form">
        <div class="form-group">
          <div class="phone-input">
            <input
              type="text"
              v-model="passwordForm.phone"
              placeholder="请输入手机号"
              maxlength="11"
            >
          </div>
        </div>
        <div class="form-group">
          <div class="password-input">
            <input
              :type="showPassword ? 'text' : 'password'"
              v-model="passwordForm.password"
              placeholder="请输入密码"
            >
            <button class="toggle-password" @click="showPassword = !showPassword">
              <i :class="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
            </button>
          </div>
          <div class="forgot-password">
            <router-link to="/reset-password">忘记密码？</router-link>
          </div>
        </div>
        
        <!-- 记住账号选项 -->
        <div class="form-group remember-group">
          <label class="remember-checkbox">
            <input type="checkbox" v-model="rememberAccount">
            <span class="checkmark"></span>
            记住账号
          </label>
        </div>
        
        <button class="login-btn" @click="handlePasswordLogin">登录</button>
      </div>

      <div class="login-footer">
        <p>登录即表示同意</p>
        <div class="agreement-links">
          <router-link to="/terms">服务条款</router-link>
          <span>和</span>
          <router-link to="/privacy">隐私政策</router-link>
        </div>
        <div class="register-tip">
          还没有账号？
          <router-link to="/register" class="register-link">立即注册</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { eventBus } from '@/utils/eventBus'

export default {
  name: 'LoginView',
  data() {
    return {
      passwordForm: {
        phone: '',
        password: ''
      },
      showPassword: false,
      rememberAccount: true // 默认勾选记住账号
    }
  },
  
  mounted() {
    this.loadRememberedAccount()
  },
  
  methods: {
    // 加载记住的账号信息
    loadRememberedAccount() {
      try {
        const rememberedPhone = localStorage.getItem('rememberedPhone')
        const isRememberEnabled = localStorage.getItem('rememberAccount')
        
        if (isRememberEnabled === 'true' && rememberedPhone) {
          this.passwordForm.phone = rememberedPhone
          this.rememberAccount = true
        }
      } catch (error) {
        console.error('加载记住的账号失败:', error)
      }
    },
    
    // 保存或清除记住的账号
    handleRememberAccount() {
      try {
        if (this.rememberAccount && this.passwordForm.phone) {
          // 保存账号信息
          localStorage.setItem('rememberedPhone', this.passwordForm.phone)
          localStorage.setItem('rememberAccount', 'true')
        } else {
          // 清除记住的账号信息
          localStorage.removeItem('rememberedPhone')
          localStorage.setItem('rememberAccount', 'false')
        }
      } catch (error) {
        console.error('保存记住账号设置失败:', error)
      }
    },
    
    async handlePasswordLogin() {
      if (!this.passwordForm.phone || !this.passwordForm.password) {
        this.$message.warning('请输入手机号和密码')
        return
      }

      try {
        const response = await fetch('/api/auth/password/login', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(this.passwordForm)
        })
        const data = await response.json()
        if (data.ok) {
          // 登录成功后处理记住账号
          this.handleRememberAccount()
          
          // 保存登录信息
          localStorage.setItem('token', data.data.token)
          localStorage.setItem('userInfo', JSON.stringify({
            id: data.data.id,
            nickname: data.data.nickname,
            avatar: data.data.avatar,
            phone: this.passwordForm.phone
          }))
          
          this.$message.success('登录成功')
          eventBus.$emit('login-success')
          
          // 检查是否有重定向参数
          const redirect = this.$route.query.redirect || '/'
          this.$router.push(redirect)
        } else {
          this.$message.error(data.msg || '登录失败')
        }
      } catch (error) {
        console.error('登录失败:', error)
        this.$message.error('登录失败，请稍后重试')
      }
    }
  },
  
  watch: {
    // 监听记住账号选项的变化
    rememberAccount(newVal) {
      if (!newVal) {
        // 如果取消勾选，立即清除记住的账号
        localStorage.removeItem('rememberedPhone')
        localStorage.setItem('rememberAccount', 'false')
      }
    }
  }
}
</script>

<style scoped>
.login-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
  padding: 20px;
}

.login-container {
  background: white;
  padding: 40px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  width: 100%;
  max-width: 400px;
}

.login-container h2 {
  text-align: center;
  margin-bottom: 30px;
  color: #333;
  font-weight: 600;
}

.form-group {
  margin-bottom: 20px;
}

.phone-input,
.password-input {
  display: flex;
  border: 1px solid #ddd;
  border-radius: 4px;
  overflow: hidden;
}

.phone-input input,
.password-input input {
  flex: 1;
  padding: 12px;
  border: none;
  outline: none;
  font-size: 14px;
}

.toggle-password {
  padding: 0 15px;
  border: none;
  background: none;
  cursor: pointer;
  color: #666;
}

/* 记住账号样式 */
.remember-group {
  margin-bottom: 25px;
}

.remember-checkbox {
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: 14px;
  color: #666;
  user-select: none;
}

.remember-checkbox input[type="checkbox"] {
  display: none;
}

.checkmark {
  width: 18px;
  height: 18px;
  border: 2px solid #ddd;
  border-radius: 3px;
  margin-right: 8px;
  position: relative;
  transition: all 0.3s ease;
}

.remember-checkbox input[type="checkbox"]:checked + .checkmark {
  background-color: #4CAF50;
  border-color: #4CAF50;
}

.remember-checkbox input[type="checkbox"]:checked + .checkmark::after {
  content: '';
  position: absolute;
  left: 5px;
  top: 2px;
  width: 4px;
  height: 8px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.login-btn {
  width: 100%;
  padding: 12px;
  background: #4CAF50;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.login-btn:hover {
  background: #43A047;
}

.login-footer {
  margin-top: 30px;
  text-align: center;
  color: #666;
  font-size: 14px;
}

.agreement-links {
  margin-top: 5px;
}

.agreement-links a {
  color: #4CAF50;
  text-decoration: none;
}

.register-tip {
  margin-top: 15px;
}

.register-link {
  color: #4CAF50;
  text-decoration: none;
}

.forgot-password {
  text-align: right;
  margin-top: 8px;
}

.forgot-password a {
  color: #666;
  font-size: 14px;
  text-decoration: none;
}

.forgot-password a:hover {
  color: #4CAF50;
}
</style>
